import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'do0027',
    ecrans: ['00-2'],
    params: ['id', '?rlrcleint', '?datdebemp']
});
